import { Box } from "@vinomofo/components";
import { InputMock } from "./Mock";

export const ProductPreloader = () => {
  return (
    <Box
      width="100%"
      maxWidth="1200px"
      margin="0 auto"
      display="flex"
      flexDirection={["column", "row"]}
      justifyContent="space-between"
      padding={[20, 40]}
    >
      <Box
        width={["100%", "65%"]}
        display="flex"
        flexDirection="column"
        mt={[3, 4]}
      >
        <Box mb={4}>
          <InputMock height={30} width="80%" />
          <Box mt={2}>
            <InputMock height={30} width="60%" />
          </Box>
        </Box>

        <Box display="flex" alignItems="center" mb={4}>
          <Box display="flex" gridGap="8px">
            {[...Array(5)].map((_, index) => (
              <Box
                key={index}
                width="45px"
                height="45px"
                borderRadius="50%"
                overflow="hidden"
              >
                <InputMock height={45} width="45px" />
              </Box>
            ))}
          </Box>
        </Box>

        <Box display="flex" gridGap="15px" mb={3}>
          <InputMock height={30} width="180px" />
          <InputMock height={30} width="180px" />
        </Box>
      </Box>

      <Box
        width={["100%", "30%"]}
        backgroundColor="white"
        borderRadius="8px"
        padding={3}
      >
        <InputMock height={30} width="100%" />

        <Box mt={3}>
          <Box display="flex" gridGap="10px" mb={2}>
            <InputMock height={30} width="40%" />
            <InputMock height={30} width="40%" />
          </Box>

          <InputMock height={30} width="100%" mb={2} />

          <Box mt={3}>
            <InputMock height={30} width="100%" mb={1} />
            <InputMock height={30} width="90%" mb={1} />
            <InputMock height={30} width="95%" mb={1} />
            <InputMock height={30} width="85%" />
          </Box>

          <Box mt={4}>
            <InputMock height={30} width="40%" mb={2} />
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <InputMock height={30} width="40%" />
              <InputMock height={40} width="100px" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
